module.exports = __webpack_public_path__ + "img/10_67.0d286b9d.png";